import React from "react";
import Button from "../Button";
import {useModal} from "../RegModal/ModalContext";
import styles from './styles.module.scss';

export default function Try() {
  const { showModal } = useModal();

  return <div className={styles.input} onClick={showModal}>
    <div className={styles.content}>
      <div>
        <span className={styles.placeholder}>请输入您的手机号码</span>
      </div>
      <Button className={styles.btn}>
        <img src="./static-official/images/send.svg"/>
        免费试用
      </Button>
    </div>
  </div>
}

export function TryBtn(props: {width?: string}) {
  const {width = "302px"} = props
  const { showModal } = useModal();

  return <Button type="outline" withArrow width={width} onClick={showModal}>立即体验</Button>
}
